import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { UserState } from '../types'

import getUserFirstName from './getUserFirstName'
import getUserRoles from './getUserRoles'
import getProjectAccessUserRoles from './getProjectAccessUserRoles'
import checkAccessUserPermission from './checkAccessUserPermission'
import hasUserAccessToProject from './hasUserAccessToProject'
import getUserLogo from './getUserLogo'
import getUserId from './getUserId'
import getUserLocalId from './getUserLocalId'
import getUserLastName from './getUserLastName'
import getUserFullName from './getUserFullName'
import getUserPosition from './getUserPosition'
import userIsAdmin from './userIsAdmin'
import userHasRole from './userHasRole'
import getUserEmail from './getUserEmail'
import getUserActiveTo from './getUserActiveTo'
import isShowNotificationMobile from './isShowNotificationMobile'
import userIsGlobalAdmin from './userIsGlobalAdmin'
import getUserTgProxyLink from './getUserTgProxyLink'
import getUserDisabledSoundNotifications from './getUserDisabledSoundNotifications'
import getUserDisabledTextNotifications from './getUserDisabledTextNotifications'

const getters: GetterTree<UserState, RootState> = {
  getUserLogo,
  getUserId,
  getUserLocalId,
  getUserFullName,
  getUserFirstName,
  getUserLastName,
  getUserPosition,
  getUserRoles,
  getProjectAccessUserRoles,
  checkAccessUserPermission,
  hasUserAccessToProject,
  userIsAdmin,
  getUserEmail,
  userHasRole,
  getUserActiveTo,
  isShowNotificationMobile,
  userIsGlobalAdmin,
  getUserTgProxyLink,
  getUserDisabledSoundNotifications,
  getUserDisabledTextNotifications,
}

export default getters
